import config from "config/config";
import { getToken } from "js/formatting/getToken";

export async function getAgentFormsByDocument(company, state) {
  let options = {
    method: "GET",
    headers: {
      Accept: "application/json",
      "Content-Type": "application/json",
      Authorization: `bearer ${getToken()}`,
    },
  };
  let url = `${config.REG_API_BASE_URL}/Forms?Portal=agent&Company=${company}&State=${state}`;

  const response = await fetch(url, options);
  if (!response.ok) {
    throw response;
  } else {
    const data = await response.json();
    return data;
  }
}
